<template>
    <ContentPage title="Commissioni - Acquirente">
        <div>
            <p>
                Salvo diverso accordo scritto ovvero diversa indicazione delle Condizioni particolari d’asta, le Commissioni dovute dall’acquirente a
                Fleequid per la compravendita di ogni singolo veicolo realizzata con l’impiego del Marketplace ovvero dei servizi e sistemi di
                compravendita di Fleequid sono le seguenti:
            </p>
        </div>

        <div class="mx-auto flex flex-col items-center gap-2">
            <div>
                <SaleFeesInfoTable />
            </div>
        </div>

        <div>
            <p><strong>*</strong> al netto di IVA</p>
            <p><strong>**</strong> oltre ad IVA se applicabile</p>
        </div>

        <div>
            <p class="mb-1 font-bold">Esempio 1:</p>
            <p>Prezzo di aggiudicazione: 6.000&nbsp;€ +&nbsp;IVA</p>
            <p>
                Commissione dovuta a Fleequid dall'Acquirente: <br class="md:hidden" />
                <span class="font-medium">
                    importo fisso di 250&nbsp;€ +&nbsp;(6.000&nbsp;€ * 8,75%) =
                    <span class="whitespace-nowrap">775&nbsp;€ +&nbsp;IVA</span>
                </span>
            </p>
        </div>

        <div>
            <p class="mb-1 font-bold">Esempio 2:</p>
            <p>Prezzo di Aggiudicazione: 180.000&nbsp;€ +&nbsp;IVA</p>
            <p>
                Commissione dovuta a Fleequid dall'Acquirente: <br class="md:hidden" />
                <span class="font-medium">
                    250&nbsp;€ +&nbsp;(100.000&nbsp;€ * 8,75%) +&nbsp;(80.000&nbsp;€ * 3,75%) =
                    <span class="whitespace-nowrap">12.000&nbsp;€ +&nbsp;IVA</span>
                </span>
            </p>
        </div>
    </ContentPage>
</template>
